import React from 'react'
import { Image, Typography, Row, Col } from 'antd'
import CustomButton from "../../components/CustomButton/Button"
import { useNavigate } from 'react-router-dom'
import NotFoundImage from "../../assets/images/404.png"
import "./Error.scss"

const { Title } = Typography

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Row className='error-row-container' align="middle">
      <Col xs={24} sm={24} md={12}>
        <div className='error-message-container'>
          <Title level={1} className='oops-text'>
            Oops!
          </Title>
          <Title level={3} className='error-text'>
            Page Doesn't Exist
          </Title>
          <CustomButton
            variant="solid"
            color="primary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </CustomButton>
        </div>
      </Col>
      <Col xs={24} sm={24} md={12}>
        <div className='not-found-image'>
          <Image src={NotFoundImage} preview={false} alt='Not Found' height={500}/>
        </div>
      </Col>
    </Row>
  )
}

export default NotFound